"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createWrapper = void 0;
var lodash_1 = require("lodash");
var OG_SCORM_WRAPPER_1 = __importDefault(require("./OG-SCORM-WRAPPER"));
var scormKeymap_1 = require("./scormKeymap");
var localforage_1 = __importDefault(require("localforage"));
var constants_1 = require("./constants");
var utils_1 = __importDefault(require("./utils"));
var logger_1 = __importDefault(require("./logger"));
var dayjs_1 = __importDefault(require("dayjs"));
var formatTimeAccordingToCurrentStorageType = function (storageType, timeInMs) {
    if (storageType === "1.2")
        return utils_1.default.scorm12FormatTime(timeInMs);
    if (storageType === "2004")
        return utils_1.default.scorm2004FormatSessionTime(timeInMs);
    if (storageType === "local")
        return timeInMs.toString();
};
var DEFAULT_DEBOUNCE_DELAY_IN_MS = 300;
/**
 * SCORM storage types
 * @typedef {"1.2" | "2004" | "local"} SCORMStorageType
 */
/**
 * Creates an interface between the LMS API and the custom module
 * @param {Object} config - The wrapper configuration
 * @param {SCORMStorageType} config.baseStorageType - The targeted SCORM storage type
 * @param {Object} config.scormAPIInterface - A way to override pipewek behaviour
 * @param {boolean} [config.shouldStoreEverythingInSuspendData=false] - Indicates whether objectives and interactions should be stored in suspend data
 * @param {Object} [config.debounceCommits = {}] - Object indicating how to debounce commits (if needed)
 * @param {boolean} config.debounceCommits.isActive - Activate debounce or not
 * @param {number} config.debounceCommits.delayInMs - Commit delay
 * @param {Object} [config.debug = {}] - Object indicating how to provide debug data
 * @param {MinLogLevel} config.debug.minLogLevel - Filter applied on log levels printed
 * @param {boolean} config.debug.sendLogs - Tells whether logs should be forwarded to Datadog
 * @param {Object} config.debug.context - Add some contexts to Datadog logs
 * @param {string} config.debug.context.env - Context environment (production, preprod... for instance)
 * @param {string} config.debug.context.service - Name of the service (product name for instance)
 * @returns A SCORM interface to communicate with LMS
 */
var create = function (_a) {
    var baseStorageType = _a.baseStorageType, _b = _a.scormAPIInterface, scormAPIInterface = _b === void 0 ? OG_SCORM_WRAPPER_1.default : _b, _c = _a.shouldStoreEverythingInSuspendData, shouldStoreEverythingInSuspendData = _c === void 0 ? false : _c, _d = _a.debounceCommits, debounceCommits = _d === void 0 ? {} : _d, _e = _a.debug, debug = _e === void 0 ? {} : _e, moduleId = _a.moduleId, filteredScormValues = _a.filteredScormValues;
    var debugOptions = Object.assign({ minLogLevel: "error", sendLogs: false, context: {} }, debug);
    var logger = new logger_1.default(debugOptions.context, {
        minLogLevel: debugOptions.minLogLevel,
        sendLogs: debugOptions.sendLogs,
    });
    scormAPIInterface.UTILS.trace = function (msg, level) {
        if (level === void 0) { level = "info"; }
        return logger[level] && logger[level](msg);
    };
    var debounceOptions = Object.assign({ isActive: false, delayInMs: DEFAULT_DEBOUNCE_DELAY_IN_MS }, debounceCommits);
    var debouncedSave;
    if (debounceOptions.isActive) {
        debouncedSave = (0, lodash_1.debounce)(function () { return scormAPIInterface.SCORM.save(); }, debounceOptions.delayInMs);
    }
    else {
        debouncedSave = function () { return scormAPIInterface.SCORM.save(); };
        debouncedSave.cancel = function () { return undefined; };
        debouncedSave.flush = function () { return scormAPIInterface.SCORM.save(); };
    }
    var startTime;
    if (moduleId && /^[a-z0-9_]+$/i.test(moduleId)) {
        localforage_1.default.config({ storeName: moduleId, name: "@upandgo_scorm-wrapper" });
    }
    var init = function (_a) {
        var _b = _a.startSession, startSession = _b === void 0 ? true : _b;
        return __awaiter(void 0, void 0, void 0, function () {
            var success;
            return __generator(this, function (_c) {
                success = true;
                if (startSession)
                    startTime = new Date();
                if (baseStorageType !== "local") {
                    success = scormAPIInterface.SCORM.init();
                    window.addEventListener("unload", function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    debouncedSave.flush();
                                    return [4 /*yield*/, close()];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); });
                }
                logger.info("Initialize storage type to ".concat(baseStorageType, " with result ").concat(success));
                return [2 /*return*/, success];
            });
        });
    };
    var setInteractionData = function (storageType) {
        return function (key, index, data) { return __awaiter(void 0, void 0, void 0, function () {
            var interactionDataKey, suspendDataString, suspendData;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        interactionDataKey = scormKeymap_1.interactionKeyMap[key][storageType];
                        if (!shouldStoreEverythingInSuspendData) return [3 /*break*/, 3];
                        return [4 /*yield*/, getBaseData(storageType)("suspendData")];
                    case 1:
                        suspendDataString = _b.sent();
                        suspendData = suspendDataString
                            ? JSON.parse(suspendDataString)
                            : { objectiveList: [], interactionList: [] };
                        suspendData.interactionList[index] = __assign(__assign({}, suspendData.interactionList[index]), (_a = {}, _a[interactionDataKey] = data, _a));
                        return [4 /*yield*/, setBaseData(storageType)("suspendData", JSON.stringify(suspendData))];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        if (interactionDataKey === "timestamp" && storageType === "2004") {
                            setData("cmi.interactions.".concat(index, ".").concat(interactionDataKey), utils_1.default.scorm2004FormatInteractionTimestamp(data), storageType);
                        }
                        else {
                            setData("cmi.interactions.".concat(index, ".").concat(interactionDataKey), data, storageType);
                        }
                        _b.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        }); };
    };
    var getInteractionData = function (storageType) {
        return function (key, index) { return __awaiter(void 0, void 0, void 0, function () {
            var interactionDataKey, suspendDataString, suspendData, value;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        interactionDataKey = scormKeymap_1.interactionKeyMap[key][storageType];
                        if (!shouldStoreEverythingInSuspendData) return [3 /*break*/, 2];
                        return [4 /*yield*/, getBaseData(storageType)("suspendData")];
                    case 1:
                        suspendDataString = _a.sent();
                        if (typeof suspendDataString !== "string" || suspendDataString.length === 0)
                            return [2 /*return*/, undefined];
                        suspendData = JSON.parse(suspendDataString);
                        if (!suspendData.interactionList)
                            return [2 /*return*/, undefined];
                        if (!suspendData.interactionList[index])
                            return [2 /*return*/, undefined];
                        if (!suspendData.interactionList[index][interactionDataKey])
                            return [2 /*return*/, undefined];
                        return [2 /*return*/, suspendData.interactionList[index][interactionDataKey]];
                    case 2: return [4 /*yield*/, getData("cmi.interactions.".concat(index, ".").concat(interactionDataKey), storageType)];
                    case 3:
                        value = _a.sent();
                        return [2 /*return*/, value];
                }
            });
        }); };
    };
    var setObjectiveData = function (storageType) {
        return function (key, index, data) { return __awaiter(void 0, void 0, void 0, function () {
            var objectiveDataKey, suspendDataString, suspendData;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        objectiveDataKey = scormKeymap_1.objectiveKeyMap[key][storageType];
                        if (!shouldStoreEverythingInSuspendData) return [3 /*break*/, 3];
                        return [4 /*yield*/, getBaseData(storageType)("suspendData")];
                    case 1:
                        suspendDataString = _b.sent();
                        suspendData = suspendDataString
                            ? JSON.parse(suspendDataString)
                            : { objectiveList: [], interactionList: [] };
                        suspendData.objectiveList[index] = __assign(__assign({}, suspendData.objectiveList[index]), (_a = {}, _a[objectiveDataKey] = data, _a));
                        return [4 /*yield*/, setBaseData(storageType)("suspendData", JSON.stringify(suspendData))];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        setData("cmi.objectives.".concat(index, ".").concat(objectiveDataKey), data, storageType);
                        _b.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        }); };
    };
    var getObjectiveData = function (storageType) {
        return function (key, index) { return __awaiter(void 0, void 0, void 0, function () {
            var objectiveDataKey, suspendDataString, suspendData, value;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        objectiveDataKey = scormKeymap_1.objectiveKeyMap[key][storageType];
                        if (!shouldStoreEverythingInSuspendData) return [3 /*break*/, 2];
                        return [4 /*yield*/, getBaseData(storageType)("suspendData")];
                    case 1:
                        suspendDataString = _a.sent();
                        if (typeof suspendDataString !== "string" || suspendDataString.length === 0)
                            return [2 /*return*/, undefined];
                        suspendData = JSON.parse(suspendDataString);
                        if (!suspendData.objectiveList)
                            return [2 /*return*/, undefined];
                        if (!suspendData.objectiveList[index])
                            return [2 /*return*/, undefined];
                        if (!suspendData.objectiveList[index][objectiveDataKey])
                            return [2 /*return*/, undefined];
                        return [2 /*return*/, suspendData.objectiveList[index][objectiveDataKey]];
                    case 2: return [4 /*yield*/, getData("cmi.objectives.".concat(index, ".").concat(objectiveDataKey), storageType)];
                    case 3:
                        value = _a.sent();
                        return [2 /*return*/, value];
                }
            });
        }); };
    };
    var getBaseData = function (storageType) {
        return function (key) { return __awaiter(void 0, void 0, void 0, function () {
            var normalizeKey, value;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        normalizeKey = scormKeymap_1.baseKeyMap[key][storageType];
                        return [4 /*yield*/, getData(normalizeKey, storageType)];
                    case 1:
                        value = _a.sent();
                        return [2 /*return*/, value];
                }
            });
        }); };
    };
    var setBaseData = function (storageType) {
        return function (key, value) { return __awaiter(void 0, void 0, void 0, function () {
            var normalizeKey, filteredValues, filters, filteredValueArray;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        normalizeKey = scormKeymap_1.baseKeyMap[key][storageType];
                        if (normalizeKey === null) {
                            logger.debug("No normalized key found for key < ".concat(key, " >. Not setting ").concat(key, "=").concat(value));
                            return [2 /*return*/];
                        }
                        filters = filteredScormValues;
                        if (typeof filters === "string") {
                            filteredValues = constants_1.SCORM_FILTER_PRESETS[storageType][filters][key];
                        }
                        else if (filters) {
                            filteredValues = filters[key];
                        }
                        if (filteredValues) {
                            if (filteredValues === "blockAll")
                                return [2 /*return*/];
                            filteredValueArray = Object.values(filteredValues);
                            if (filteredValueArray.includes(value)) {
                                logger.debug("Blocked value < ".concat(value, " > from ").concat(normalizeKey));
                                return [2 /*return*/];
                            }
                        }
                        logger.debug("Set base data on < ".concat(normalizeKey, " > key, with < ").concat(value, " > value"));
                        return [4 /*yield*/, setData(normalizeKey, value, storageType)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
    };
    var getProgressMeasure = function (storageType) {
        return function () { return __awaiter(void 0, void 0, void 0, function () {
            var value;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getBaseData(storageType)("progressMeasure")];
                    case 1:
                        value = _a.sent();
                        return [2 /*return*/, utils_1.default.computeLMSnumber(value)];
                }
            });
        }); };
    };
    var getGlobalScoreRaw = function (storageType) {
        return function () { return __awaiter(void 0, void 0, void 0, function () {
            var value;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getBaseData(storageType)("scoreRaw")];
                    case 1:
                        value = _a.sent();
                        return [2 /*return*/, utils_1.default.computeLMSnumber(value)];
                }
            });
        }); };
    };
    var getGlobalScoreScaled = function (storageType) {
        return function () { return __awaiter(void 0, void 0, void 0, function () {
            var value;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getBaseData(storageType)("scoreScaled")];
                    case 1:
                        value = _a.sent();
                        return [2 /*return*/, utils_1.default.computeLMSnumber(value)];
                }
            });
        }); };
    };
    var getGlobalScoreMin = function (storageType) {
        return function () { return __awaiter(void 0, void 0, void 0, function () {
            var value;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getBaseData(storageType)("scoreMin")];
                    case 1:
                        value = _a.sent();
                        return [2 /*return*/, utils_1.default.computeLMSnumber(value)];
                }
            });
        }); };
    };
    var getGlobalScoreMax = function (storageType) {
        return function () { return __awaiter(void 0, void 0, void 0, function () {
            var value;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getBaseData(storageType)("scoreMax")];
                    case 1:
                        value = _a.sent();
                        return [2 /*return*/, utils_1.default.computeLMSnumber(value)];
                }
            });
        }); };
    };
    var safelySetProgressMeasure = function (storageType) { return function (newProgessMeasure) { return __awaiter(void 0, void 0, void 0, function () {
        var previousProgressMeasure;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (storageType === "1.2")
                        return [2 /*return*/];
                    return [4 /*yield*/, getProgressMeasure(storageType)()];
                case 1:
                    previousProgressMeasure = _a.sent();
                    if (previousProgressMeasure === null || previousProgressMeasure < newProgessMeasure) {
                        return [2 /*return*/, setBaseData(storageType)("progressMeasure", Math.min(1, newProgessMeasure))];
                    }
                    return [2 /*return*/];
            }
        });
    }); }; };
    var safelySetScore = function (storageType) { return function (newScore) { return __awaiter(void 0, void 0, void 0, function () {
        var roundedScore, scoreRaw, scoreMin, scoreMax;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    roundedScore = Math.round(newScore * 100) / 100;
                    return [4 /*yield*/, getGlobalScoreRaw(storageType)()];
                case 1:
                    scoreRaw = _a.sent();
                    return [4 /*yield*/, getGlobalScoreMin(storageType)()];
                case 2:
                    scoreMin = (_a.sent()) || 0;
                    return [4 /*yield*/, getGlobalScoreMax(storageType)()];
                case 3:
                    scoreMax = (_a.sent()) || 100;
                    if (roundedScore > scoreMax) {
                        return [2 /*return*/, setBaseData(storageType)("scoreRaw", scoreMax)];
                    }
                    if (roundedScore < scoreMin) {
                        return [2 /*return*/, setBaseData(storageType)("scoreRaw", scoreMin)];
                    }
                    if (utils_1.default.computeLMSnumber(scoreRaw) && roundedScore < scoreRaw) {
                        return [2 /*return*/, setBaseData(storageType)("scoreRaw", scoreRaw)];
                    }
                    return [2 /*return*/, setBaseData(storageType)("scoreRaw", roundedScore)];
            }
        });
    }); }; };
    var safelySetScoreScaled = function (storageType) { return function (newScore) { return __awaiter(void 0, void 0, void 0, function () {
        var roundedScore, scoreScaled, scoreMin, scoreMax;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    roundedScore = Math.round(newScore * 100) / 100;
                    return [4 /*yield*/, getGlobalScoreScaled(storageType)()];
                case 1:
                    scoreScaled = _a.sent();
                    scoreMin = 0;
                    scoreMax = 1;
                    if (roundedScore > scoreMax) {
                        return [2 /*return*/, setBaseData(storageType)("scoreScaled", scoreMax)];
                    }
                    if (roundedScore < scoreMin) {
                        return [2 /*return*/, setBaseData(storageType)("scoreScaled", scoreMin)];
                    }
                    if (utils_1.default.computeLMSnumber(scoreScaled) && roundedScore < scoreScaled) {
                        return [2 /*return*/, setBaseData(storageType)("scoreScaled", scoreScaled)];
                    }
                    return [2 /*return*/, setBaseData(storageType)("scoreScaled", roundedScore)];
            }
        });
    }); }; };
    var safelySetSuccessStatus = function (storageType) {
        return function (targetedStatus) { return __awaiter(void 0, void 0, void 0, function () {
            var currentStatus, newStatus;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getBaseData(storageType)("successStatus")];
                    case 1:
                        currentStatus = _a.sent();
                        newStatus = targetedStatus;
                        if (storageType === "1.2") {
                            if (currentStatus && constants_1.ORDERED_MERGED_STATUS[currentStatus] > constants_1.ORDERED_MERGED_STATUS[targetedStatus]) {
                                newStatus = currentStatus;
                            }
                        }
                        else {
                            if (currentStatus &&
                                constants_1.ORDERED_SUCCESS_STATUS[currentStatus] >
                                    constants_1.ORDERED_SUCCESS_STATUS[targetedStatus]) {
                                newStatus = currentStatus;
                            }
                        }
                        return [2 /*return*/, setBaseData(storageType)("successStatus", newStatus)];
                }
            });
        }); };
    };
    var safelySetCompleteStatus = function (storageType) {
        return function (targetedStatus) { return __awaiter(void 0, void 0, void 0, function () {
            var currentStatus, newStatus;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getBaseData(storageType)("completeStatus")];
                    case 1:
                        currentStatus = _a.sent();
                        newStatus = targetedStatus;
                        if (storageType === "1.2") {
                            if (currentStatus && constants_1.ORDERED_MERGED_STATUS[currentStatus] > constants_1.ORDERED_MERGED_STATUS[targetedStatus]) {
                                newStatus = currentStatus;
                            }
                        }
                        else {
                            if (currentStatus &&
                                constants_1.ORDERED_COMPLETION_STATUS[currentStatus] >
                                    constants_1.ORDERED_COMPLETION_STATUS[targetedStatus]) {
                                newStatus = currentStatus;
                            }
                        }
                        return [2 /*return*/, setBaseData(storageType)("completeStatus", newStatus)];
                }
            });
        }); };
    };
    var close = function () { return __awaiter(void 0, void 0, void 0, function () {
        var duration, sessionTime, success;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!startTime) return [3 /*break*/, 2];
                    duration = (0, dayjs_1.default)(new Date().getTime() - startTime.getTime());
                    sessionTime = formatTimeAccordingToCurrentStorageType(baseStorageType, duration.valueOf());
                    return [4 /*yield*/, setBaseData(baseStorageType)("sessionTime", sessionTime)];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    if (baseStorageType !== "local") {
                        success = scormAPIInterface.SCORM.quit();
                        logger.info("Called qui function with result ".concat(success));
                        return [2 /*return*/, success];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getData = function (key, storageType) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(storageType === "local")) return [3 /*break*/, 2];
                    return [4 /*yield*/, localforage_1.default.getItem(key)];
                case 1: return [2 /*return*/, _a.sent()];
                case 2: return [2 /*return*/, scormAPIInterface.SCORM.get(key)];
            }
        });
    }); };
    var setData = function (key, value, storageType) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(storageType === "local")) return [3 /*break*/, 2];
                    return [4 /*yield*/, localforage_1.default.setItem(key, value)];
                case 1: return [2 /*return*/, _a.sent()];
                case 2:
                    scormAPIInterface.SCORM.set(key, value);
                    debouncedSave();
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return {
        version: baseStorageType,
        init: init,
        close: close,
        safelySetProgressMeasure: safelySetProgressMeasure(baseStorageType),
        safelySetScore: safelySetScore(baseStorageType),
        safelySetScoreScaled: safelySetScoreScaled(baseStorageType),
        safelySetCompleteStatus: safelySetCompleteStatus(baseStorageType),
        safelySetSuccessStatus: safelySetSuccessStatus(baseStorageType),
        getBaseData: getBaseData(baseStorageType),
        setBaseData: setBaseData(baseStorageType),
        setInteractionData: setInteractionData(baseStorageType),
        getInteractionData: getInteractionData(baseStorageType),
        setObjectiveData: setObjectiveData(baseStorageType),
        getObjectiveData: getObjectiveData(baseStorageType),
        getGlobalScoreRaw: getGlobalScoreRaw(baseStorageType),
        getGlobalScoreScaled: getGlobalScoreScaled(baseStorageType),
        getGlobalScoreMin: getGlobalScoreMin(baseStorageType),
        getGlobalScoreMax: getGlobalScoreMax(baseStorageType),
        getProgressMeasure: getProgressMeasure(baseStorageType),
    };
};
exports.createWrapper = create;
//# sourceMappingURL=wrapper.js.map